import { createClient } from '@supabase/supabase-js'

// Get environment variables
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseKey) {
  console.error('❌ Missing Supabase environment variables:')
  console.error('VITE_SUPABASE_URL:', supabaseUrl)
  console.error('VITE_SUPABASE_ANON_KEY:', supabaseKey ? 'Present' : 'Missing')
  console.error('Make sure your .env file is in the root directory and contains:')
  console.error('VITE_SUPABASE_URL=your_url')
  console.error('VITE_SUPABASE_ANON_KEY=your_key')
  throw new Error('Missing Supabase environment variables')
}

export const supabase = createClient(supabaseUrl, supabaseKey)

// Database types
export interface Database {
  public: {
    Tables: {
      village_chief: {
        Row: {
          id: string
          name: string
          title: string
          photo: string
          phone: string
          email: string
          address: string
          message: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          title: string
          photo: string
          phone: string
          email: string
          address: string
          message: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          title?: string
          photo?: string
          phone?: string
          email?: string
          address?: string
          message?: string
          created_at?: string
          updated_at?: string
        }
      }
      residents: {
        Row: {
          id: string
          name: string
          role: string
          phone: string
          email: string | null
          photo: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          role: string
          phone: string
          email?: string | null
          photo?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          role?: string
          phone?: string
          email?: string | null
          photo?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      statistics: {
        Row: {
          id: string
          label: string
          value: string
          icon: string
          description: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          label: string
          value: string
          icon: string
          description?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          label?: string
          value?: string
          icon?: string
          description?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      services: {
        Row: {
          id: string
          name: string
          category: string
          phone: string
          address: string | null
          description: string | null
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          name: string
          category: string
          phone: string
          address?: string | null
          description?: string | null
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          name?: string
          category?: string
          phone?: string
          address?: string | null
          description?: string | null
          created_at?: string
          updated_at?: string
        }
      }
      government_links: {
        Row: {
          id: string
          title: string
          description: string
          url: string
          icon: string
          category: string
          created_at: string
          updated_at: string
        }
        Insert: {
          id?: string
          title: string
          description: string
          url: string
          icon: string
          category: string
          created_at?: string
          updated_at?: string
        }
        Update: {
          id?: string
          title?: string
          description?: string
          url?: string
          icon?: string
          category?: string
          created_at?: string
          updated_at?: string
        }
      }
    }
  }
}
